import React from 'react';
import moment from 'moment';
import {fullDateShow} from '../../../../common/constants/datesFormat';

const Item = ({title, content, width}) => (
  <div className='description-kanban-item' style={{'width': `${width}%`}}>
    <p className='title'>{title}: </p>
    <p>{content}</p>
  </div>
);

const Description = ({description, width = 25}) => {
  const {
    client,
    vehicle,
    creationDate,
    color,
    creationUser,
    year,
    location,
    order,
    motor,
    suffix,
    masterCode,
    comboCode,
    chassis,
  } = description;

  return (
    <div className='description-kanban-container'>
      <Item title='Cliente' content={client} width={width} />
      <Item title='Vehículo' content={vehicle} width={width} />
      <Item title='Chasis' content={chassis} width={width} />

      <Item
        title='Modelo'
        content={`${suffix} / ${masterCode}`}
        width={width}
      />
      <Item title='Año' content={year} width={width} />
      <Item title='Motor' content={motor} width={width} />

      <Item title='Ubicación' content={location} width={width} />
      <Item title='Color' content={color} width={width} />
      <Item title='Combo' content={comboCode} width={width} />

      <Item title='Pedido' content={order} width={width} />
      <Item
        title='Usuario'
        content={creationUser ? creationUser.toUpperCase() : ''}
        width={width}
      />
      <Item
        title='Fecha'
        content={
          creationDate ?
            moment(new Date(creationDate)).format(fullDateShow) :
            ''
        }
        width={width}
      />
    </div>
  );
};

export default Description;
